import React, { FunctionComponent } from 'react';
import { DeepLinkBanner } from 'components/DeepLinkBanner';
import { useNativeEvents } from 'hooks/useNativeEvents';
import { useAppSelector } from 'hooks/redux';

export const EventDeepLinkBanner: FunctionComponent = () => {
  const { nativeUrlSchemeLink } = useNativeEvents();
  const requiresAccesscode = useAppSelector(
    (state) => state.channel.requiresAccesscode
  );
  const channelDetails = useAppSelector(
    (state) => state.channel.channelDetails
  );
  const channelAccesscodeDetails = useAppSelector(
    (state) => state.channel.accessCodeDetails
  );

  const deepLink = nativeUrlSchemeLink('mixlr', 'event', {
    url: window.location.href,
    channel_url: window.location.origin,
    channel_name: requiresAccesscode
      ? channelAccesscodeDetails?.username
      : channelDetails?.username,
    channel_theme_color: requiresAccesscode
      ? channelAccesscodeDetails?.themeColor
      : channelDetails?.themeColor,
    channel_logo_url: requiresAccesscode
      ? channelAccesscodeDetails?.channelLogo.image.small
      : channelDetails?.channelLogo.image.small
  });

  return <DeepLinkBanner deepLink={deepLink} />;
};
